module.exports = __webpack_public_path__ + "img/add-member-plus.e5a045ad.svg";